// Saw Sharpening: something to take care of in the future: https://github.com/erikras/ducks-modular-redux

import {
	combineReducers
} from 'redux';
import tacRed from './tacRed';
import toggleFSLOadingRed from './toggleFSLOadingRed';
import getAzureProviderRelationshipRed from './getAzureProviderRelationshipRed';
import fetchUsersListRed from './fetchUsersListRed';
import fetchMonthToDateRed from './fetchMonthToDateRed';
import createNewUserRed from './createNewUserRed';
import { routerReducer } from 'react-router-redux';


const lastErrorMessage = (state = null, action) => {
	const {
		type,
		error
	} = action

	if (type === 'RESET_ERROR_MESSAGE') {
		return null
	} else if (error) {
		return action.error
	}

	return state
};

const appReducer = combineReducers({ // appReducer is our root reducer that will combine the s#!7 of 'em all! :P
	tacRed, // This will calls the reducer with a part of state called "tacRed", if is needed to pass a diferent part then define a key with that parts name :( statePart: tacRed)
	toggleFSLOadingRed,
	getAzureProviderRelationshipRed,
	lastErrorMessage,
	fetchUsersListRed,
	fetchMonthToDateRed,
	createNewUserRed,
	routing: routerReducer
});

export default appReducer


/** WEBPACK FOOTER **
 ** ./src/reducers/index.js
 **/